import { AppUserRoleMapping } from "models/AppUserRoleMapping";
import { Permission } from "models/Permission";
import { RoleFieldEntityMapping } from "models/RoleFieldEntityMapping";
import { Site } from "models/Site";
import { Status } from "models/Status";
import { Model } from "react3l-common";
import { Field } from "react3l-decorators";

export class Role extends Model {
  @Field(Number)
  public id?: number;

  @Field(String)
  public code?: string;

  @Field(String)
  public name?: string;

  @Field(Number)
  public statusId?: number = 1;

  @Field(Boolean)
  public isTendering?: boolean = false;

  @Field(Number)
  public siteId?: number;

  @Field(Boolean)
  public used?: boolean;

  @Field(Number)
  public roleTypeId?: number;

  public status?: Status;

  public site?: Site;

  public appUserRoleMappings?: AppUserRoleMapping[];

  public roleFieldEntityMappings?: RoleFieldEntityMapping[];

  public permissions?: Permission[];
}
